export const messages = {
  en: {
    carStructure: {
      noOwner: 'No Owner',
      oweAmount: 'Arrears',
      yuan: 'Yuan',
      searchPlaceholder: 'Please enter house number building-unit-room such as 1-1-1',
      fetchError: 'Failed to fetch car structure data',
      page: {
        title: 'Vehicle Structure',
        subtitle: 'View parking space occupancy and arrears by building and unit',
        listTitle: 'Parking Space Grid',
        empty: 'No parking space data for the selected unit'
      },
      state: {
        noOwner: 'No Owner',
        arrears: 'Arrears',
        normal: 'Normal'
      }
    },
    floorUnitTree: {
      noBuilding: 'No building currently',
      building: 'Building',
      unit: 'Unit',
      fetchError: 'Failed to fetch floor and unit data'
    }
  },
  zh: {
    carStructure: {
      noOwner: '无',
      oweAmount: '欠费',
      yuan: '元',
      searchPlaceholder: '请输入房屋编号 楼栋-单元-房屋 如1-1-1',
      fetchError: '获取车位结构数据失败',
      page: {
        title: '车辆结构',
        subtitle: '按楼栋与单元查看车位占用与欠费情况',
        listTitle: '车位分布',
        empty: '当前单元暂无车位数据'
      },
      state: {
        noOwner: '无业主',
        arrears: '有欠费',
        normal: '正常'
      }
    },
    floorUnitTree: {
      noBuilding: '当前没有楼栋',
      building: '栋',
      unit: '单元',
      fetchError: '获取楼栋单元数据失败'
    }
  }
}